/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Vue from 'vue'
import axios from '@/axios.js'
import con from "@/firebase/firebaseInit.ts";
import ls from "@/common/localStorage"

//var cn = 'OA_UAT_C1591205467009E1591206650065';
var cn = ls.getSessionEventCollectionName();
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');

var FETCHCHECKINSETTINGSAPIURL = con.checkinSettingsFetchAPi;
var ADDCHCHECKINROLEAPIURL = con.checkinRoleAddAPi;
var SCHEDULEGLOBALCHECKOUTAPIURL = con.scheduleGlobalCheckout;

export default {
    fetchGeoCheckinSettings({ commit }) {
        return new Promise((resolve, reject) => {      
          let headers = {
              "Content-Type": "application/json",
              'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
              "iid": "OA_UAT",
              "cid": Session_Client_Id,
              "eid": Session_Event_Id
          }

          axios.get(FETCHCHECKINSETTINGSAPIURL, { headers: headers }).then(function (res) {
            debugger;
            console.log("res====",res);
            if(res.data.status == 0){
                if (res.data.results.DelayOffsetSeconds) {
                    res.data.results.DelayOffsetSeconds = Math.floor(res.data.results.DelayOffsetSeconds / 60);
                }
                resolve(res.data.results) 
            }
          }).catch(err=>{ reject(err) })
             
        })
    },
    addUpdateSettings(context, field) {
      return new Promise((resolve, reject) => {
        console.log("called===",field);

        let docObj = {
          autoCheckOutMessage: field.data.autoCheckOutMessage,
          checkoutTime: field.data.checkoutTime,
          isAutoCheckOutEnabled: field.data.isAutoCheckOutEnabled,
          DelayOffsetSeconds: field.data.DelayOffsetSeconds ? field.data.DelayOffsetSeconds * 60 : 1800
      }
      let accessToken = ls.getSessionValueByKey('Session_AccessToken');
      let headers = {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${accessToken}`,
      }
      let requestData = {
          "key": {
              "instanceId": "OA_UAT",
              "clientId": Session_Client_Id,
              "eventId": Session_Event_Id
          },
          "data": docObj,
      };
      axios.post(FETCHCHECKINSETTINGSAPIURL, requestData, { headers: headers }).then(function (res) {
          if (res.status == 200) {
              if (res.data.status == 0) {
                  resolve({ status: 200, message: 'Settings Added/Updated Succesfully.' })
              }
          }
      }).catch(function (error) {
          console.log(error)
          reject(error)
      })
      })
  },
  UpdateGlobalSchedular(context) {
    return new Promise((resolve, reject) => {

  
    let accessToken = ls.getSessionValueByKey('Session_AccessToken');
    let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${accessToken}`,
    }
    let requestData = {
        "key": {
            "instanceId": "OA_UAT",
            "clientId": Session_Client_Id,
            "eventId": Session_Event_Id
        },
      
    };
    axios.post(SCHEDULEGLOBALCHECKOUTAPIURL, requestData, { headers: headers }).then(function (res) {
        if (res.status == 200) {
            if (res.data.status == 0) {
                resolve({ status: 200, message: 'Settings Added/Updated Succesfully.' })
            }
        }
    }).catch(function (error) {
        console.log(error)
        reject(error)
    })
    })
},
}